import {makeStyles} from "@mui/styles";

export const useStyles = makeStyles({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '36px',
    },
    btn_remove: {
        width: '100%',
    },
    btn__wrapper : {
        display: 'flex',
    },
    btn: {
        width: '100%',
    },
    row_left: {
        display: 'inline-block',
        maxWidth: 192,
        width: '100%',
        marginRight: 16,
    },
    row_right: {
        display: 'inline-block',
        maxWidth: 192,
        width: '100%',
    }
});
